import {padStart} from 'lodash';
import {DateFormatType} from './CommonTypes';

export class DateUtils {
    public static format(date: Date, type: DateFormatType = DateFormatType.DateTime, ms: boolean = false): string {
        let result = '';

        let day = date.getDay().toString();
        let month = date.getMonth().toString();
        let year = date.getFullYear().toString();

        if (type === DateFormatType.Date || type === DateFormatType.DateTime) {
            result = padStart(day, 2, '0') + '.' +
                     padStart(month, 2, '0') + '.' +
                     year;
        }

        if (type === DateFormatType.DateTime || type === DateFormatType.Time) {
            let hh = date.getHours().toString();
            let mm = date.getMinutes().toString();
            let sec = date.getSeconds().toString();
            let millis = date.getMilliseconds().toString();

            if (result.length > 0) {
                result += ' ';
            }

            result += padStart(hh, 2, '0') + ':' +
                      padStart(mm, 2, '0') + ':' +
                      padStart(sec, 2, '0');

            if (ms === true) {
                result += '.' + padStart(millis, 3, '0');
            }
        }

        return result;
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Utils/DateUtils.ts
 **/